import { getCachedMediaUrl } from '../../../../../lib/utils/utils';

function OfferCard({ offer }) {
    return (
        <div className='w-[158px] h-auto rounded-xl overflow-hidden shrink-0'>
            <img className='w-full h-auto' src={getCachedMediaUrl(offer.couponImage)} alt={offer.couponName} />
        </div>
    );
}

function OfferDisplayDesktop({ item }) {
    return (
        <div className='w-full flex flex-col gap-2'>
            <p className='px-4 font-semibold text-[14px] leading-5 text-[#000000]'>{item.item.name}</p>

            <div className="px-4 w-full flex flex-nowrap gap-3 overflow-x-scroll no-scrollbar">
                {item.item.offersList?.map(offer => {
                    return (
                        <OfferCard 
                            key={offer.id} 
                            offer={offer} 
                        />
                    )
                })}
            </div>
        </div>
    );
}

export default OfferDisplayDesktop;
